import React from "react";
import { Grid, useMediaQuery, useTheme, Stack } from "@mui/material";

interface MasonryGridProps {
  items: any[];
  renderItem: (item: any, index: number) => React.ReactNode;
  breakpoint?: string; // e.g. "md", "sm", "lg" - default "md"
  spacing?: number;
}

const MasonryGrid: React.FC<MasonryGridProps> = ({
  items,
  renderItem,
  breakpoint = "md",
  spacing = 2,
}) => {
  const theme = useTheme();
  // @ts-ignore
  const isSmallScreen = useMediaQuery(theme.breakpoints.down(breakpoint));

  const leftCol: any[] = [];
  const rightCol: any[] = [];

  if (items && items.length > 0) {
    items.forEach((item, index) => {
      if (index % 2 === 0) {
        leftCol.push(item);
      } else {
        rightCol.push(item);
      }
    });
  }

  if (isSmallScreen) {
    return (
      <Stack spacing={spacing}>
        {items.map((item, index) => renderItem(item, index))}
      </Stack>
    );
  }

  return (
    <Grid container spacing={spacing}>
      <Grid item xs={6}>
        <Stack spacing={spacing}>
          {leftCol.map((item, index) => {
              // Calculate original index to pass correctly if needed
              const originalIndex = index * 2;
              return renderItem(item, originalIndex);
          })}
        </Stack>
      </Grid>
      <Grid item xs={6}>
        <Stack spacing={spacing}>
          {rightCol.map((item, index) => {
              // Calculate original index to pass correctly if needed
              const originalIndex = (index * 2) + 1;
              return renderItem(item, originalIndex);
          })}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default MasonryGrid;
